"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var constants = tslib_1.__importStar(require("./constants"));
var aesjs = tslib_1.__importStar(require("aes-js"));
var btoa;
exports.btoa = btoa;
if ('btoa' in global) {
    exports.btoa = btoa = function (key) { return global.btoa(key); };
}
else {
    exports.btoa = btoa = function (input) {
        var buffer;
        if (input instanceof Buffer) {
            buffer = input;
        }
        else {
            buffer = Buffer.from(input.toString(), 'binary');
        }
        return buffer.toString('base64');
    };
}
var RAND = Math.PI.toString();
var keygen = function (key) {
    return btoa(String(key).concat(RAND))
        .split('')
        .reverse()
        .map(function (c) { return c.charCodeAt(0); })
        .slice(0, 16);
};
var Encrypter = /** @class */ (function () {
    function Encrypter(salt) {
        this.counterLength = 5;
        this.key = keygen(salt);
    }
    Encrypter.prototype.encryptText = function (text) {
        var textBytes = aesjs.utils.utf8.toBytes(text);
        var aesCtr = new aesjs.ModeOfOperation.ctr(this.key, new aesjs.Counter(this.counterLength));
        var encryptedBytes = aesCtr.encrypt(textBytes);
        return aesjs.utils.hex.fromBytes(encryptedBytes);
    };
    Encrypter.prototype.decryptText = function (encryptedHex) {
        var encryptedBytes = aesjs.utils.hex.toBytes(encryptedHex);
        var aesCtr = new aesjs.ModeOfOperation.ctr(this.key, new aesjs.Counter(this.counterLength));
        var decryptedBytes = aesCtr.decrypt(encryptedBytes);
        return aesjs.utils.utf8.fromBytes(decryptedBytes);
    };
    return Encrypter;
}());
exports.Encrypter = Encrypter;
var encrypter = new Encrypter(JSON.stringify(constants));
exports.default = encrypter;
